(function () {
  'use strict';

  function money(root, cents) {
    var currency = root.getAttribute('data-currency') || 'USD';
    var locale = root.getAttribute('data-locale') || 'en-US';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (_) {
      return (cents / 100).toFixed(2);
    }
  }

  function readJson(root, selector, fallback) {
    var node = root.querySelector(selector);
    if (!node) return fallback;
    try { return JSON.parse(node.textContent); } catch (_) { return fallback; }
  }

  function resolveContractState(root, variants) {
    if (root.hasAttribute('data-aorvo-public-display')) {
      root.removeAttribute('data-aorvo-public-view-validated');
      var value;
      try { value = JSON.parse(root.getAttribute('data-aorvo-public-payload')); } catch (_) { return false; }
      var ids = readJson(root, '[data-aorvo-product-media-ids]', []);
      var pub = window.AorvoPdpContractAdapter && window.AorvoPdpContractAdapter.resolvePublicView(value, {
        productGid: root.getAttribute('data-product-gid'), productType: root.getAttribute('data-product-type'),
        productHandle: root.getAttribute('data-product-handle'), variants: variants,
        variantGids: variants.map(function(v){return 'gid://shopify/ProductVariant/'+String(v.id);}),
        mediaGids: ids.map(function(id){return 'gid://shopify/MediaImage/'+String(id);})
      });
      if (!pub || !pub.ok) { root.aorvoPdpViewModel = null; root.setAttribute('data-aorvo-display-error',pub ? pub.reason : 'PUBLIC_CONSUMER_ABSENT'); return false; }
      root.aorvoPdpViewModel = pub.model;
      root.setAttribute('data-aorvo-public-view-validated','true');
      return true;
    }
    var raw = root.getAttribute('data-aorvo-projection-payload');
    if (!raw) return true;
    var projection;
    try { projection = JSON.parse(raw); } catch (_) { return false; }
    if (projection.PROJECTION_ID === 'AORVO_PRODUCT_STOREFRONT_PROJECTION_CANDIDATE_V1') return true;
    var adapter = window.AorvoPdpContractAdapter;
    if (!adapter) return false;
    var mediaIds = readJson(root, '[data-aorvo-product-media-ids]', []);
    if (!Array.isArray(mediaIds) || !Array.isArray(variants)) return false;
    var context = {
      productGid: root.getAttribute('data-product-gid'),
      productType: root.getAttribute('data-product-type'),
      productHandle: root.getAttribute('data-product-handle'),
      variantGids: variants.map(function (v) { return 'gid://shopify/ProductVariant/' + String(v.id); }),
      variants: variants,
      mediaGids: mediaIds.map(function (id) { return 'gid://shopify/MediaImage/' + String(id); })
    };
    if (projection.PROJECTION_ID === 'AORVO_PRODUCT_STOREFRONT_PROJECTION_CANDIDATE_V1_2' || projection.PROJECTION_ID === 'AORVO_PRODUCT_STOREFRONT_PROJECTION_CANDIDATE_V1_3') {
      if (root.aorvoPdpViewModel && root.aorvoPdpViewModel.attestationVerified &&
          (projection.PROJECTION_ID !== 'AORVO_PRODUCT_STOREFRONT_PROJECTION_CANDIDATE_V1_3' ||
           (root.aorvoPdpVerifiedPayload === raw && root.aorvoPdpVerifiedContext === JSON.stringify(context)))) return true;
      return adapter.resolveAttested(projection, context).then(function (resolved) {
        if (!resolved.ok) { root.setAttribute('data-aorvo-contract-error', resolved.reason); return false; }
        root.aorvoPdpViewModel = resolved.model;
        root.aorvoPdpVerifiedPayload = raw;
        root.aorvoPdpVerifiedContext = JSON.stringify(context);
        return true;
      });
    }
    var resolved = adapter.resolve(projection, context);
    if (!resolved.ok) {
      root.setAttribute('data-aorvo-contract-error', resolved.reason);
      return false;
    }
    root.aorvoPdpViewModel = resolved.model;
    return true;
  }

  function setText(root, selector, value) {
    var node = root.querySelector(selector);
    if (node) node.textContent = value;
  }

  function setInput(form, name, value) {
    if (!form) return;
    var input = form.querySelector('[name="' + name + '"]');
    if (!input) return;
    input.value = String(value);
    input.setAttribute('value', String(value));
  }

  function selectedQuantity(root) {
    var input = root.querySelector('[data-aorvo-main-form] [name="quantity"]');
    var value = Number(input && input.value);
    return Number.isInteger(value) && value > 0 ? value : 1;
  }

  function purchaseEnabled(root, enabled) {
    root.querySelectorAll('[data-aorvo-main-form] [name="add"], [data-aorvo-sticky-form] [name="add"]').forEach(function (button) {
      button.disabled = !enabled;
      button.setAttribute('aria-disabled', enabled ? 'false' : 'true');
    });
    var main = root.querySelector('[data-aorvo-main-form]');
    var sticky = root.querySelector('[data-aorvo-sticky-form]');
    if (main) main.inert = false;
    if (sticky) sticky.inert = !enabled;
  }

  // Presentation only: Product price x raw selected quantity, never the cart subtotal.
  function updateSelectionOffer(root) {
    var row = root.querySelector('[data-aorvo-selection-tier]');
    var offer = root.querySelector('[data-aorvo-offer]');
    if (!row || !offer) return;
    var button = row.querySelector('button');
    var input = root.querySelector('[data-aorvo-main-form] [name="quantity"]');
    var identity = root.querySelector('[data-aorvo-main-form] [name="id"]');
    var state = root.aorvoCurrentState;
    var quantity = Number(input && input.value);
    var subtotal = state && state.price * quantity;
    var resolver = window.AorvoTieredOffer;
    var valid = Boolean(state && state.available && identity && identity.value === state.variantId &&
      root.getAttribute('data-currency') === 'USD' && Number.isSafeInteger(state.price) && state.price >= 0 &&
      Number.isSafeInteger(quantity) && quantity > 0 && Number.isSafeInteger(subtotal) &&
      resolver && typeof resolver.resolveTier === 'function');
    var tier = valid ? resolver.resolveTier(subtotal) : null;
    valid = Boolean(valid && tier && tier.code && Number.isInteger(tier.percent) &&
      tier.percent > 0 && tier.percent <= 100 && Number.isSafeInteger(subtotal * tier.percent));
    row.hidden = !valid;
    offer.hidden = !valid;
    if (!valid) {
      button.removeAttribute('data-aorvo-copy-code');
      setText(root, '[data-aorvo-selection-code]', '');
      setText(root, '[data-aorvo-after-code]', '');
      setText(root, '[data-aorvo-savings]', '');
      setText(root, '[data-aorvo-copy-status]', '');
      return;
    }
    if (button.getAttribute('data-aorvo-copy-code') !== tier.code) {
      setText(root, '[data-aorvo-copy-label]', button.dataset.copyLabel);
      setText(root, '[data-aorvo-copy-status]', '');
    }
    button.setAttribute('data-aorvo-copy-code', tier.code);
    setText(root, '[data-aorvo-selection-code]', tier.code);
    setText(root, '[data-aorvo-selection-percent]', tier.percent + '%');
    setText(root, '[data-aorvo-selection-minimum]', tier.threshold === 0 ? 'No minimum' : money(root, tier.threshold) + ' merchandise subtotal');
    setText(root, '[data-aorvo-selection-quantity]', String(quantity));
    setText(root, '[data-aorvo-selection-subtotal]', money(root, subtotal));
    var savings = Math.round(subtotal * tier.percent / 100);
    setText(root, '[data-aorvo-savings]', money(root, savings));
    setText(root, '[data-aorvo-after-code]', money(root, subtotal - savings));
  }

  function syncQuantity(root) {
    var quantity = selectedQuantity(root);
    setInput(root.querySelector('[data-aorvo-sticky-form]'), 'quantity', quantity);
    var state = root.aorvoCurrentState;
    if (state) root.aorvoCurrentState = Object.freeze(Object.assign({}, state, { quantity: quantity }));
    updateSelectionOffer(root);
  }

  function syncPublicReferenceCaptions(root, variant, selected) {
    root.querySelectorAll('[data-aorvo-public-reference-context]').forEach(function (note) {
      note.hidden = true; note.textContent = '';
    });
    var model = root.aorvoPdpViewModel;
    if (!model || model.PUBLIC_DISPLAY_VIEW !== 1 || !selected ||
        root.getAttribute('data-aorvo-public-view-validated') !== 'true' ||
        model.productId !== root.getAttribute('data-product-gid') ||
        !variant.featured_media || selected.heroMediaId !== 'gid://shopify/MediaImage/' + String(variant.featured_media.id)) return;
    var roles = { 'Room / Installed': 'ROOM_INSTALLED', 'Detail / Craftsmanship': 'DETAIL_CRAFTSMANSHIP', 'Dimension / Scale': 'DIMENSION_SCALE' };
    root.querySelectorAll('figure[data-aorvo-approved-role][data-aorvo-source-id]').forEach(function (figure) {
      var role = roles[figure.getAttribute('data-aorvo-approved-role')];
      if (!role) return;
      var mediaId = figure.getAttribute('data-aorvo-source-id');
      var matches = selected.media.filter(function (m) {
        return m.mediaId === 'gid://shopify/MediaImage/' + mediaId && m.role === role && !m.hidden &&
          typeof m.contextLabel === 'string' && m.contextLabel.trim() && m.contextLabel !== 'Shown configuration: Default Title';
      });
      if (matches.length !== 1) return;
      var note = figure.querySelector('[data-aorvo-public-reference-context]');
      if (!note && role === 'ROOM_INSTALLED') {
        var existing = Array.from(root.querySelectorAll('[data-aorvo-room-note][data-aorvo-public-room-context]')).filter(function (item) { return item.getAttribute('data-aorvo-context-media') === mediaId; });
        if (existing.length > 1) return;
        if (existing.length === 1) note = existing[0];
      }
      if (!note) {
        note = document.createElement('figcaption');
        note.className = 'aorvo-pdp-canary__room-context';
        note.setAttribute('data-aorvo-public-reference-context', 'true');
        note.setAttribute('data-aorvo-context-media', mediaId);
        if (role === 'ROOM_INSTALLED') {
          note.setAttribute('data-aorvo-room-note', '');
          note.setAttribute('data-aorvo-public-room-context', '');
        }
        figure.append(note);
      }
      note.textContent = matches[0].contextLabel; note.hidden = false;
    });
  }

  function roomContext(root, variant) {
    if (root.hasAttribute('data-aorvo-public-display')) {
      var model = root.aorvoPdpViewModel;
      var selected = model && model.PUBLIC_DISPLAY_VIEW === 1 && model.variants.find(function (v) { return v.variantId === 'gid://shopify/ProductVariant/' + String(variant.id); });
      root.querySelectorAll('[data-aorvo-room-note]').forEach(function (note) {
        var mediaId = 'gid://shopify/MediaImage/' + note.getAttribute('data-aorvo-context-media');
        var matches = selected ? selected.media.filter(function (m) { return m.mediaId === mediaId && m.role === 'ROOM_INSTALLED' && !m.hidden && typeof m.contextLabel === 'string' && m.contextLabel.trim(); }) : [];
        note.hidden = matches.length !== 1 || !note.hasAttribute('data-aorvo-public-room-context');
        if (!note.hidden) note.textContent = matches[0].contextLabel;
      });
      syncPublicReferenceCaptions(root, variant, selected);
      return;
    }
    root.querySelectorAll('[data-aorvo-room-note]').forEach(function (note) {
      var scope = note.getAttribute('data-aorvo-context-scope');
      var approvedVariant = note.getAttribute('data-aorvo-context-variant');
      note.hidden = scope !== 'PRODUCT_SHARED' && approvedVariant !== String(variant.id);
      if (!note.hidden && root.querySelector('product-variant-dropdown[data-no-options="true"]') &&
          note.textContent.trim() === 'Shown configuration: Default Title') note.hidden = true;
    });
  }

  function galleryCaption(root, renderer) {
    var anchor = root.querySelector('[data-aorvo-gallery-caption]');
    var gallery = root.querySelector('#proFeaturedImageZoom');
    if (!anchor || !gallery) return;
    function hide() {
      anchor.hidden = true;
      anchor.textContent = '';
      anchor.removeAttribute('data-aorvo-caption-media');
    }
    function sync() {
      hide();
      if (!renderer || !renderer.ownsMedia() || renderer.applying ||
          root.getAttribute('data-aorvo-media-empty') === 'true' ||
          !root.aorvoCurrentState || !window.jQuery) return;
      var slider = window.jQuery(gallery);
      if (!slider.hasClass('slick-initialized') || slider.slick('getSlick').animating) return;
      var active = gallery.querySelectorAll('.slick-current:not(.slick-cloned)[data-media-source-id]');
      if (active.length !== 1) return;
      var mediaId = active[0].getAttribute('data-media-source-id');
      var image = active[0].querySelector('img');
      if (!image || !image.complete || !image.naturalWidth) return;
      var view = renderer.currentViewModel;
      if (!view || !view.orderedVisibleMediaIds.includes(mediaId)) return;
      var admitted = renderer.canonicalRecords.filter(function (record) {
        return record.mediaId === mediaId && record.mediaType === 'image';
      });
      if (admitted.length !== 1 || admitted[0].slot !== active[0].getAttribute('data-aorvo-media-slot') ||
          admitted[0].role !== active[0].getAttribute('data-media-role')) return;
      if (root.aorvoPdpViewModel && root.aorvoPdpViewModel.PUBLIC_DISPLAY_VIEW === 1) {
        var selected = root.aorvoPdpViewModel.variants.find(function(v){return v.variantId === 'gid://shopify/ProductVariant/'+root.aorvoCurrentState.variantId;});
        var labels = selected ? selected.media.filter(function(m){return !m.hidden && m.mediaId === 'gid://shopify/MediaImage/'+mediaId;}) : [];
        if (labels.length === 1 && labels[0].contextLabel && labels[0].contextLabel !== 'Shown configuration: Default Title') {
          anchor.textContent = labels[0].contextLabel; anchor.setAttribute('data-aorvo-caption-media',mediaId); anchor.hidden = false;
        }
        return;
      }
      var projection;
      try { projection = JSON.parse(root.getAttribute('data-aorvo-projection-payload')); } catch (_) { return; }
      if (!projection || projection.SHOPIFY_PRODUCT_GID !== root.getAttribute('data-product-gid') ||
          !Array.isArray(projection.MEDIA_ASSETS)) return;
      var records = projection.MEDIA_ASSETS.filter(function (record) {
        return record && record.SHOPIFY_MEDIA_GID === 'gid://shopify/MediaImage/' + mediaId;
      });
      if (records.length !== 1) return;
      var record = records[0];
      var hero = admitted[0].role === 'variant-hero';
      var scopeValid = record.SCOPE === 'PRODUCT_SHARED' && !admitted[0].variantCan;
      if (record.VARIANT_CAN && record.SCOPE === record.VARIANT_CAN &&
          record.VARIANT_CAN === admitted[0].variantCan && Array.isArray(projection.VARIANT_BINDINGS)) {
        var selectedVariantGid = 'gid://shopify/ProductVariant/' + root.aorvoCurrentState.variantId;
        if (projection.PROJECTION_ID === 'AORVO_PRODUCT_STOREFRONT_PROJECTION_CANDIDATE_V1' && hero) {
          var byCan = projection.VARIANT_BINDINGS.filter(function (binding) {
            return binding && binding.VARIANT_CAN === record.VARIANT_CAN;
          });
          var byVariant = projection.VARIANT_BINDINGS.filter(function (binding) {
            return binding && binding.SHOPIFY_VARIANT_GID === selectedVariantGid;
          });
          var binding = byCan.length === 1 ? byCan[0] : null;
          var directGid = record.SHOPIFY_VARIANT_GID;
          scopeValid = Boolean(binding && byVariant.length === 1 && byVariant[0] === binding &&
            binding.SHOPIFY_VARIANT_GID === selectedVariantGid &&
            binding.HERO_SHOPIFY_MEDIA_GID === record.SHOPIFY_MEDIA_GID &&
            binding.HERO_CANONICAL_ASSET_ID === record.CANONICAL_ASSET_ID &&
            binding.HERO_SOURCE_SHA256 === record.SOURCE_SHA256 &&
            binding.CURRENT_APPROVED === 'YES' && binding.HERO_DEPLOYMENT_STATE === 'READBACK_PASS' &&
            (directGid == null || directGid === '' || directGid === selectedVariantGid));
        } else {
          scopeValid = record.SHOPIFY_VARIANT_GID === selectedVariantGid &&
            projection.VARIANT_BINDINGS.filter(function (binding) {
              return binding.VARIANT_CAN === record.VARIANT_CAN &&
                binding.SHOPIFY_VARIANT_GID === record.SHOPIFY_VARIANT_GID && binding.CURRENT_APPROVED === 'YES';
            }).length === 1;
        }
      }
      if (!scopeValid || record.PARENT !== projection.PARENT_ID || !record.SLOT ||
          record.SLOT !== admitted[0].slot || typeof record.MEDIA_ROLE !== 'string' ||
          (hero ? record.MEDIA_ROLE !== 'Hero / Variant Main' : !record.MEDIA_ROLE.trim()) ||
          !record.CANONICAL_ASSET_ID || !/^[0-9a-f]{64}$/i.test(record.SOURCE_SHA256 || '') ||
          !record.QA_RECEIPT_REF || record.APPROVAL_STATE !== 'APPROVED' ||
          record.QA_STATE !== 'PASS' || record.CURRENT_APPROVED !== 'YES' ||
          record.SHOPIFY_DEPLOYMENT_STATE !== 'READBACK_PASS' ||
          record.CONTEXT_LABEL_APPROVAL_STATE !== 'APPROVED_EXACT_SOURCE_SHA_QA' ||
          typeof record.APPROVED_CONTEXT_LABEL !== 'string' || !record.APPROVED_CONTEXT_LABEL.trim()) return;
      if (root.aorvoPdpViewModel) {
        var applicable = window.AorvoPdpContractAdapter.visibleMedia(root.aorvoPdpViewModel,
          'gid://shopify/ProductVariant/' + root.aorvoCurrentState.variantId);
        var exact = applicable.ok ? applicable.media.filter(function (item) {
          return item.mediaGid === record.SHOPIFY_MEDIA_GID && item.slot === record.SLOT &&
            item.assetId === record.CANONICAL_ASSET_ID &&
            item.sourceSha === record.SOURCE_SHA256.toUpperCase() && item.scope === record.SCOPE &&
            item.contextLabel === record.APPROVED_CONTEXT_LABEL;
        }) : [];
        if (exact.length !== 1) return;
      }
      if (root.querySelector('product-variant-dropdown[data-no-options="true"]') &&
          record.APPROVED_CONTEXT_LABEL.trim() === 'Shown configuration: Default Title') return;
      anchor.textContent = record.APPROVED_CONTEXT_LABEL;
      anchor.setAttribute('data-aorvo-caption-media', mediaId);
      anchor.hidden = false;
    }
    if (!gallery.aorvoCaptionSync) {
      var pending = false;
      function schedule() {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(function () { pending = false; sync(); });
      }
      gallery.aorvoCaptionSync = sync;
      window.jQuery(gallery).on('beforeChange.aorvoCaption', hide)
        .on('init.aorvoCaption reInit.aorvoCaption afterChange.aorvoCaption', schedule);
      gallery.addEventListener('load', schedule, true);
      new MutationObserver(schedule).observe(gallery, {
        subtree: true, childList: true, attributes: true,
        attributeFilter: ['class', 'data-media-source-id']
      });
    }
    gallery.aorvoCaptionSync();
  }

  function renderElectricalFacts(root, state) {
    var hosts = root.querySelectorAll('[data-aorvo-electrical-facts]');
    hosts.forEach(function (host) { host.replaceChildren(); host.hidden = true; });
    if (hosts.length !== 1 || !state || root.aorvoCurrentState !== state) return;
    var host = hosts[0];
    if (root.aorvoPdpViewModel && root.aorvoPdpViewModel.PUBLIC_DISPLAY_VIEW === 1) {
      var pv = root.aorvoPdpViewModel.variants.find(function(v){return v.variantId === 'gid://shopify/ProductVariant/'+state.variantId;});
      if (!pv || root.aorvoPdpViewModel.category !== 'LIGHTING') return;
      function entry(label,text){var dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=label;dd.textContent=text;host.append(dt,dd);}
      var electricalLabels = ['Bulb base','Socket base','Socket','Connection','Number of lights','Light source','Voltage'];
      pv.facts.filter(function(f){return electricalLabels.includes(f.label) && f.label !== 'Voltage';}).forEach(function(f){entry(f.label,f.text);});
      var supply = {"EXCEPTIONS": [], "DISPLAY": {"label": "Voltage", "value": "110V–240V (Available)", "clarification": "International voltage options are available upon request. Please contact us before ordering to confirm the required configuration.", "preserve_already_approved_equivalent_available_text": true, "maximum_voltage_rows_per_existing_electrical_host": 1}};
      // This accepted store-wide service text is not a product rated voltage.
      if (supply.EXCEPTIONS.length) { root.setAttribute('data-aorvo-display-error','SUPPLY_EXCEPTION_REQUIRES_EXACT_PRIVATE_SELECTION'); return; }
      entry(supply.DISPLAY.label,supply.DISPLAY.value);
      var note=document.createElement('dd');note.textContent=supply.DISPLAY.clarification;host.append(note);
      host.hidden=false;return;
    }
    var projection;
    try { projection = JSON.parse(root.getAttribute('data-aorvo-projection-payload')); } catch (_) { return; }
    var legacyElectrical = projection && projection.PROJECTION_ID === 'AORVO_PRODUCT_STOREFRONT_PROJECTION_CANDIDATE_V1' &&
      projection.PRODUCT_STANDARD === 'AORVO_PRODUCT_UNIFIED_STANDARD_V2.0.3';
    var model = root.aorvoPdpViewModel;
    var adapterElectrical = projection && model && model.category === 'LIGHTING' &&
      model.parentId === projection.PARENT_ID && model.productIdentity === projection.SHOPIFY_PRODUCT_GID &&
      model.projectionId === projection.PROJECTION_ID &&
      ((projection.PROJECTION_ID === 'AORVO_PRODUCT_STOREFRONT_PROJECTION_CANDIDATE_V1_1' &&
        projection.PRODUCT_STANDARD === 'AORVO_PRODUCT_UNIFIED_STANDARD_V2.0.3') ||
       (model.attestationVerified === true && root.aorvoPdpVerifiedPayload === root.getAttribute('data-aorvo-projection-payload') &&
        ((projection.PROJECTION_ID === 'AORVO_PRODUCT_STOREFRONT_PROJECTION_CANDIDATE_V1_2' && projection.PRODUCT_STANDARD === 'AORVO_PRODUCT_UNIFIED_STANDARD_V2.1.0') ||
         (projection.PROJECTION_ID === 'AORVO_PRODUCT_STOREFRONT_PROJECTION_CANDIDATE_V1_3' && projection.PRODUCT_STANDARD === 'AORVO_PRODUCT_UNIFIED_STANDARD_V2.1.1'))));
    if (!projection || (!legacyElectrical && !adapterElectrical) ||
        projection.PRODUCT_CATEGORY !== 'LIGHTING' || typeof projection.PARENT_ID !== 'string' ||
        !projection.PARENT_ID || projection.SHOPIFY_PRODUCT_GID !== root.getAttribute('data-product-gid') ||
        projection.HANDLE !== root.getAttribute('data-product-handle') ||
        projection.SHOPIFY_PRODUCT_TYPE !== root.getAttribute('data-product-type') || !projection.PRODUCT_CLASS ||
        projection.CLASS_MAPPING_APPROVAL_STATE !== 'APPROVED' || !projection.CLASS_MAPPING_SOURCE_REF ||
        host.getAttribute('data-aorvo-electrical-parent') !== projection.PARENT_ID ||
        host.getAttribute('data-aorvo-electrical-product-gid') !== projection.SHOPIFY_PRODUCT_GID) return;
    var master = projection.MASTER_REF;
    var parentPath = '/PRODUCTS/' + projection.PARENT_ID + '/';
    if (!master || typeof master.path !== 'string' || !master.path.includes(parentPath) ||
        !master.path.endsWith('/MASTER_INSTANCE.json') || !/^[a-f0-9]{64}$/i.test(master.sha256 || '') ||
        !master.version || master.approval_state !== 'APPROVED' || master.qa_state !== 'PASS' ||
        master.current !== 'YES' || !Array.isArray(projection.FACTS) ||
        !Array.isArray(projection.VARIANT_BINDINGS)) return;
    var masterDirectory = master.path.slice(0, -'/MASTER_INSTANCE.json'.length);
    var variants = readJson(root, '[data-aorvo-variants]', []);
    if (!Array.isArray(variants) || !variants.length || variants.some(function (variant) {
      return !variant || !/^\d+$/.test(String(variant.id));
    })) return;
    var nativeGids = variants.map(function (variant) { return 'gid://shopify/ProductVariant/' + String(variant.id); });
    var selectedGid = 'gid://shopify/ProductVariant/' + state.variantId;
    var bindings = projection.VARIANT_BINDINGS;
    if (new Set(nativeGids).size !== nativeGids.length || !nativeGids.includes(selectedGid) ||
        bindings.length !== nativeGids.length || bindings.some(function (binding) {
          return !binding || binding.CURRENT_APPROVED !== 'YES' || !binding.VARIANT_CAN ||
            !nativeGids.includes(binding.SHOPIFY_VARIANT_GID);
        }) || new Set(bindings.map(function (binding) { return binding.SHOPIFY_VARIANT_GID; })).size !== nativeGids.length ||
        new Set(bindings.map(function (binding) { return binding.VARIANT_CAN; })).size !== nativeGids.length) return;
    // Owner-approved on-request supply service; never rewrites FACTS or rated input.
    var supply = {"EXCEPTIONS": [], "DISPLAY": {"label": "Voltage", "value": "110V–240V (Available)", "clarification": "International voltage options are available upon request. Please contact us before ordering to confirm the required configuration.", "preserve_already_approved_equivalent_available_text": true, "maximum_voltage_rows_per_existing_electrical_host": 1}};
    var supplyException = supply.EXCEPTIONS.some(function (entry) {
      return entry.PARENT_ID === projection.PARENT_ID &&
        (!entry.VARIANT_GID || entry.VARIANT_GID === selectedGid);
    });
    var supplyEnabled = !supplyException;
    var electricalLabels = { socket_base: 'Bulb base', connection: 'Connection', light_count: 'Number of lights', light_source_type: 'Light source', voltage: 'Voltage' };
    ['socket_base', 'connection', 'light_count', 'light_source_type', 'voltage'].forEach(function (field) {
      if (field === 'voltage' && supplyEnabled) return;
      var matches = projection.FACTS.filter(function (fact) { return fact && fact.FIELD_ID === field; });
      if (matches.length !== 1) return; // Conflicting source rows isolate only this field.
      var fact = matches[0];
      if (fact.PARENT_ID !== projection.PARENT_ID || fact.FACT_GROUP !== 'PRODUCT' || !fact.FACT_ID ||
          !fact.FACT_REF || fact.SOURCE_AUTHORITY !== 'APPROVED' || fact.APPROVAL_STATE !== 'APPROVED' ||
          fact.QA_STATE !== 'PASS' || fact.CURRENT !== 'YES' ||
          ['REVOKED', 'REJECTED', 'DENIED', 'BLOCKED', 'HOLD'].includes(fact.DISPLAY_APPROVAL_STATE)) return;
      if (legacyElectrical && (fact.FACT_REF !== masterDirectory + '/FACT_REFERENCES.json#/' + field ||
          !Array.isArray(fact.SOURCE_REFERENCE) || !fact.SOURCE_REFERENCE.length ||
          fact.SOURCE_REFERENCE.some(function (source) {
            return typeof source !== 'string' || !source.trim();
          }))) return;
      var displayResult = window.AorvoPdpContractAdapter && window.AorvoPdpContractAdapter.resolveFactDisplay(projection, fact, selectedGid);
      if (!displayResult || !['PUBLIC_APPROVED', 'APPROVED_VARIANT_VALUE', 'LEGACY_TECHNICAL_ELIGIBLE'].includes(displayResult.status)) return;
      var value = fact.CUSTOMER_VALUE, text, label = electricalLabels[field];
      if (field === 'light_count') {
        // Fact/source approval alone does not authorize public light-count display.
        if (fact.DISPLAY_APPROVAL_STATE !== 'APPROVED' ||
            typeof fact.APPROVED_DISPLAY_LABEL !== 'string' || !fact.APPROVED_DISPLAY_LABEL.trim()) return;
        if (Array.isArray(value)) {
          if (fact.APPROVED_DISPLAY_TEXT != null) return; // Consume the approved selected map only.
          if (value.length !== nativeGids.length || value.some(function (entry) {
            return !entry || Object.keys(entry).some(function (key) { return !['variant_gid', 'count'].includes(key); }) || !nativeGids.includes(entry.variant_gid) || !Number.isSafeInteger(entry.count) || entry.count <= 0;
          }) || new Set(value.map(function (entry) { return entry.variant_gid; })).size !== nativeGids.length) return;
          var selected = value.filter(function (entry) { return entry.variant_gid === selectedGid; });
          if (selected.length !== 1) return;
          text = String(selected[0].count);
        } else {
          if (!Number.isSafeInteger(value) || value <= 0) return;
          text = String(value);
        }
      } else {
        if (typeof value !== 'string' || !value.trim()) return; // An absent optional value is simply omitted.
        text = value;
      }
      // Qualified Product technical values need no redundant editorial approval. Reuse an existing
      // approved customer rendering when supplied; never manufacture approval properties in FACTS.
      var displayApproved = fact.DISPLAY_APPROVAL_STATE === 'APPROVED' &&
        typeof fact.APPROVED_DISPLAY_LABEL === 'string' && fact.APPROVED_DISPLAY_LABEL.trim();
      if (displayApproved) {
        label = fact.APPROVED_DISPLAY_LABEL;
        if (!Array.isArray(value) && typeof fact.APPROVED_DISPLAY_TEXT === 'string' && fact.APPROVED_DISPLAY_TEXT.trim()) {
          if (legacyElectrical) {
            if (field === 'light_count' && fact.APPROVED_DISPLAY_TEXT !== String(value)) return;
            if (field !== 'light_count' && (field === 'connection' ? fact.APPROVED_DISPLAY_TEXT.toLowerCase() !== value.toLowerCase() : fact.APPROVED_DISPLAY_TEXT !== value)) return;
            text = fact.APPROVED_DISPLAY_TEXT;
          } else {
            var displays = Array.isArray(model.approvedFacts) ? model.approvedFacts.filter(function (item) {
              return item.ref === fact.FACT_REF && item.group === 'PRODUCT' && item.label === label && item.text === fact.APPROVED_DISPLAY_TEXT;
            }) : [];
            if (displays.length !== 1) return;
            text = displays[0].text;
          }
        }
      }
      text = displayResult.text;
      label = displayResult.label || label;
      var row = document.createElement('div');
      row.className = 'aorvo-pdp-fact';
      row.setAttribute('data-aorvo-electrical-field', field);
      row.setAttribute('data-aorvo-fact-id', fact.FACT_ID);
      row.setAttribute('data-aorvo-electrical-source', displayApproved ? 'approved-customer-display' : 'verified-product-technical-value');
      var term = document.createElement('dt');
      var description = document.createElement('dd');
      term.textContent = label;
      description.textContent = text;
      row.append(term, description);
      host.append(row);
    });
    if (supplyEnabled) {
      var supplied = projection.FACTS.filter(function (fact) {
        return fact && fact.FIELD_ID === 'voltage' && fact.PARENT_ID === projection.PARENT_ID &&
          fact.APPROVAL_STATE === 'APPROVED' && fact.QA_STATE === 'PASS' && fact.CURRENT === 'YES' &&
          fact.DISPLAY_APPROVAL_STATE === 'APPROVED' && fact.APPROVED_DISPLAY_LABEL === 'Voltage' &&
          fact.CUSTOMER_VALUE === fact.APPROVED_DISPLAY_TEXT &&
          /^110V[-–]240V \(Available\)$/.test(fact.APPROVED_DISPLAY_TEXT || '');
      });
      var row = document.createElement('div');
      row.className = 'aorvo-pdp-fact';
      row.setAttribute('data-aorvo-electrical-field', 'voltage');
      row.setAttribute('data-aorvo-supply-policy', 'AORVO_GLOBAL_LIGHTING_SUPPLY_DISPLAY_V1');
      row.setAttribute('style', 'grid-column: 1 / -1;');
      var label = document.createElement('dt');
      var description = document.createElement('dd');
      label.textContent = supply.DISPLAY.label;
      description.textContent = supplied.length === 1 ? supplied[0].APPROVED_DISPLAY_TEXT : supply.DISPLAY.value;
      var clarification = document.createElement('p');
      clarification.textContent = supply.DISPLAY.clarification;
      clarification.setAttribute('style', 'font-weight: 400; font-size: 12px; line-height: 1.6; margin: 8px 0 0;');
      description.append(clarification);
      row.append(label, description);
      host.append(row);
    }
    host.hidden = host.childElementCount === 0;
  }


  function failClosed(root) {
    root.removeAttribute('data-aorvo-public-view-validated');
    if (root.hasAttribute('data-aorvo-contract-pending') || root.aorvoPdpViewModel?.attestationVerified) root.setAttribute('data-aorvo-contract-pending', 'true');
    root.aorvoCurrentState = null;
    root.querySelectorAll('[data-aorvo-public-reference-context]').forEach(function (note) { note.hidden = true; note.textContent = ''; });
    renderElectricalFacts(root, null);
    if (window.AorvoPdpKeyDetails) window.AorvoPdpKeyDetails.render(root, null);
    var caption = root.querySelector('[data-aorvo-gallery-caption]');
    if (caption) { caption.hidden = true; caption.textContent = ''; caption.removeAttribute('data-aorvo-caption-media'); }
    root.removeAttribute('data-selected-variant-id');
    setText(root, '[data-aorvo-sku]', '');
    setText(root, '[data-aorvo-price]', '');
    setText(root, '[data-aorvo-sticky-price]', '');
    setText(root, '[data-aorvo-configuration]', '');
    setText(root, '[data-aorvo-sticky-configuration]', '');
    var stickyImage = root.querySelector('[data-aorvo-sticky-image]');
    if (stickyImage) { stickyImage.hidden = true; stickyImage.removeAttribute('src'); stickyImage.removeAttribute('srcset'); }
    var compare = root.querySelector('[data-aorvo-compare]');
    var offer = root.querySelector('[data-aorvo-offer]');
    var notes = root.querySelectorAll('[data-aorvo-room-note]');
    if (compare) compare.hidden = true;
    if (offer) offer.hidden = true;
    notes.forEach(function (note) { note.hidden = true; });
    var contractDetails = root.querySelector('[data-aorvo-key-details-mode="contract"]');
    if (contractDetails) contractDetails.hidden = true;
    setInput(root.querySelector('[data-aorvo-main-form]'), 'id', '');
    setInput(root.querySelector('[data-aorvo-sticky-form]'), 'id', '');
    purchaseEnabled(root, false);
    root.setAttribute('data-aorvo-state', 'unresolved');
    updateSelectionOffer(root);
    return false;
  }

  function transition(picker, variant) {
    var root = picker && picker.closest('[data-aorvo-pdp-canary]');
    var nativeCommerce = root && root.getAttribute('data-aorvo-native-commerce') === 'true';
    if (!root || !variant || !variant.id ||
        !Number.isInteger(Number(variant.price)) || Number(variant.price) < 0) {
      return root ? failClosed(root) : false;
    }
    if (nativeCommerce) {
      var nativeMatches = readJson(root, '[data-aorvo-variants]', []).filter(function (item) {
        return String(item.id) === String(variant.id);
      });
      if (nativeMatches.length !== 1 || !variant.sku ||
          nativeMatches[0].sku !== variant.sku || nativeMatches[0].price !== variant.price ||
          nativeMatches[0].available !== variant.available ||
          JSON.stringify(nativeMatches[0].options) !== JSON.stringify(variant.options)) return failClosed(root);
    } else if (!variant.featured_media || !variant.featured_media.id) return failClosed(root);
    var renderer = window.novtheme && window.novtheme.getVariantMediaRenderer &&
      window.novtheme.getVariantMediaRenderer(picker.dataset.productId);
    var variantGid = 'gid://shopify/ProductVariant/' + String(variant.id);
    var mediaConfirmed = (function () {
      if (!variant.featured_media || !variant.featured_media.id) return false;
      if (root.hasAttribute('data-aorvo-public-display')) {
        if (!resolveContractState(root,readJson(root,'[data-aorvo-variants]',[])) || !renderer || !renderer.ownsMedia()) return false;
        var publicView=root.aorvoPdpViewModel.variants.find(function(v){return v.variantId==='gid://shopify/ProductVariant/'+String(variant.id);});
        if (!publicView || publicView.heroMediaId!=='gid://shopify/MediaImage/'+String(variant.featured_media.id)) return false;
        if (!renderer.renderVariant(variant)) return false;
        var expected=publicView.media.filter(function(m){return !m.hidden;}).map(function(m){return m.mediaId.split('/').pop();});
        return renderer.currentViewModel.orderedVisibleMediaIds.length===expected.length && renderer.currentViewModel.orderedVisibleMediaIds.every(function(id){return expected.includes(id);});
      }
    var heroBindings = readJson(root, '[data-aorvo-variant-hero-bindings]', []);
    var variantGid = 'gid://shopify/ProductVariant/' + String(variant.id);
    var mediaGid = 'gid://shopify/MediaImage/' + String(variant.featured_media.id);
    var matchingHero = heroBindings.filter(function (binding) {
      return binding && binding.SHOPIFY_VARIANT_GID === variantGid &&
        binding.HERO_SHOPIFY_MEDIA_GID === mediaGid &&
        binding.CURRENT_APPROVED === 'YES' &&
        binding.HERO_DEPLOYMENT_STATE === 'READBACK_PASS' &&
        typeof binding.HERO_CANONICAL_ASSET_ID === 'string' &&
        binding.HERO_CANONICAL_ASSET_ID.length > 0 &&
        /^[0-9a-f]{64}$/i.test(binding.HERO_SOURCE_SHA256 || '');
    });
    var canonicalHeroCount = renderer && renderer.canonicalRecords ?
      renderer.canonicalRecords.filter(function (record) {
        return record.role === 'variant-hero' &&
          record.mediaId === String(variant.featured_media.id);
      }).length : 0;
    if (root.aorvoPdpViewModel) {
      var applicable = window.AorvoPdpContractAdapter.visibleMedia(root.aorvoPdpViewModel, variantGid);
      if (!applicable.ok) return false;
      var approvedIds = new Set(applicable.media.map(function (item) { return item.mediaGid.split('/').pop(); }));
      if (!renderer || renderer.canonicalRecords.some(function (record) {
        return !root.aorvoPdpViewModel.media.some(function (item) { return item.mediaGid.endsWith('/' + record.mediaId); });
      }) || !approvedIds.has(String(variant.featured_media.id))) return false;
    }
    if (matchingHero.length !== 1 || canonicalHeroCount !== 1 ||
        !renderer || !renderer.ownsMedia() || !renderer.renderVariant(variant)) return false;
    if (root.aorvoPdpViewModel) {
      var expectedIds = new Set(window.AorvoPdpContractAdapter.visibleMedia(root.aorvoPdpViewModel, variantGid).media.map(function (item) { return item.mediaGid.split('/').pop(); }));
      var visibleIds = renderer.currentViewModel.orderedVisibleMediaIds;
      if (visibleIds.length !== expectedIds.size || visibleIds.some(function (id) { return !expectedIds.has(id); })) return false;
    }
      return true;
    })();
    if (!mediaConfirmed && !nativeCommerce) return failClosed(root);
    if (nativeCommerce) {
      root.setAttribute('data-aorvo-media-empty', String(!mediaConfirmed));
    }
    var revision = (Number(root.getAttribute('data-aorvo-revision')) || 0) + 1;
    var price = Number(variant.price);
    var compareAt = Number(variant.compare_at_price);
    var available = Boolean(variant.available);
    var state = Object.freeze({
      revision: revision,
      variantId: String(variant.id),
      sku: variant.sku || '',
      price: price,
      compareAt: compareAt,
      available: available,
      quantity: selectedQuantity(root),
      featuredMediaId: mediaConfirmed ? String(variant.featured_media.id) : null
    });

    // All commerce fields are committed from this exact variant before the form can submit.
    root.aorvoCurrentState = state;
    root.setAttribute('data-aorvo-revision', String(revision));
    root.setAttribute('data-selected-variant-id', state.variantId);
    setText(root, '[data-aorvo-sku]', state.sku);
    setText(root, '[data-aorvo-price]', money(root, price));
    setText(root, '[data-aorvo-sticky-price]', money(root, price));
    setText(root, '[data-aorvo-configuration]', variant.title || variant.options.join(' / '));
    setText(root, '[data-aorvo-sticky-configuration]', variant.title || variant.options.join(' / '));
    var stickyImage = root.querySelector('[data-aorvo-sticky-image]');
    if (stickyImage) {
      var preview = mediaConfirmed && variant.featured_media && variant.featured_media.preview_image;
      stickyImage.hidden = !preview?.src;
      stickyImage.removeAttribute('srcset');
      if (preview?.src) { var previewUrl = new URL(preview.src, location.href); previewUrl.searchParams.set('width', '96'); stickyImage.src = previewUrl.href; }
      else stickyImage.removeAttribute('src');
    }
    var compare = root.querySelector('[data-aorvo-compare]');
    if (compare) {
      compare.hidden = !(Number.isFinite(compareAt) && compareAt > price);
      if (!compare.hidden) compare.textContent = money(root, compareAt);
    }
    setInput(root.querySelector('[data-aorvo-main-form]'), 'id', state.variantId);
    setInput(root.querySelector('[data-aorvo-sticky-form]'), 'id', state.variantId);
    syncQuantity(root);
    picker.querySelectorAll('fieldset, .product-form__input--dropdown').forEach(function (group, index) {
      var label = group.querySelector('.variant_current');
      if (label && variant.options[index] !== undefined) label.textContent = variant.options[index];
    });
    var productSelect = root.querySelector('#productSelect');
    if (productSelect) productSelect.value = state.variantId;
    var quantityInput = root.querySelector('[data-aorvo-main-form] [name="quantity"]');
    if (quantityInput) {
      if (variant.inventory_management === 'shopify' && variant.inventory_policy !== 'continue' &&
          Number(variant.inventory_quantity) > 0) {
        quantityInput.max = String(variant.inventory_quantity);
      } else {
        quantityInput.removeAttribute('max');
      }
    }
    roomContext(root, variant, renderer);
    galleryCaption(root, renderer);
    if (root.aorvoPdpViewModel && !root.aorvoPdpViewModel.PUBLIC_DISPLAY_VIEW) {
      var selectedBinding = root.aorvoPdpViewModel.variantBindings.find(function (binding) {
        return binding.SHOPIFY_VARIANT_GID === variantGid;
      });
      root.querySelectorAll('[data-aorvo-module-variant-can]').forEach(function (module) {
        module.hidden = !selectedBinding || module.getAttribute('data-aorvo-module-variant-can') !== selectedBinding.VARIANT_CAN;
      });
    }
    if (window.AorvoPdpKeyDetails) window.AorvoPdpKeyDetails.render(root, state.variantId);
    renderElectricalFacts(root, root.aorvoCurrentState);
    setText(root, '[data-aorvo-main-cta-label]', available ? 'Add to Bag' : 'Unavailable');
    setText(root, '[data-aorvo-sticky-cta-label]', available ? 'Add to Bag' : 'Unavailable');
    purchaseEnabled(root, available);
    root.setAttribute('data-aorvo-state', available ? 'ready' : 'unavailable');
    if (picker.updateURL) picker.updateURL();
    return true;
  }

  function initStickyVisibility(root) {
    if (root.aorvoStickyVisibilityInitialized) return;
    var primary = root.querySelector('[data-aorvo-main-form] [name="add"]');
    var sticky = root.querySelector('[data-aorvo-sticky-form]');
    if (!primary || !sticky) return;
    root.aorvoStickyVisibilityInitialized = true;
    var mobile = window.matchMedia('(max-width: 767px)');
    var desktop = window.matchMedia('(min-width: 1200px)');
    var panel = root.querySelector('.aorvo-pdp-decision-panel');
    function primaryIntersects() {
      var rect = primary.getBoundingClientRect();
      var clip = panel.getBoundingClientRect();
      var left = Math.max(0, clip.left, rect.left);
      var top = Math.max(0, clip.top, rect.top);
      var right = Math.min(document.documentElement.clientWidth, clip.right, rect.right);
      var bottom = Math.min(document.documentElement.clientHeight, clip.bottom, rect.bottom);
      return right > left && bottom > top;
    }
    var pending = false;
    function update() {
      pending = false;
      // Visibility is layout-only. Commerce fields remain owned by transition().
      root.setAttribute('data-aorvo-sticky-visible', String(mobile.matches && primary.getBoundingClientRect().bottom <= 0));
      root.setAttribute('data-aorvo-desktop-sticky-visible', String(desktop.matches && !primaryIntersects()));
    }
    function schedule() {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(update);
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    panel.addEventListener('scroll', schedule, { passive: true });
    if (window.IntersectionObserver) {
      var observer = new window.IntersectionObserver(schedule, { threshold: [0, 1] });
      observer.observe(primary);
    }
    update();
  }

  function init(root) {
    if (root.aorvoCanaryInitialized) return;
    initStickyVisibility(root);
    var decisionLayout = window.matchMedia('(min-width: 768px)');
    function setDecisionLayout() {
      root.querySelectorAll('.aorvo-pdp-decision-module:not([data-aorvo-v2-member])').forEach(function (module) { module.open = decisionLayout.matches; });
    }
    setDecisionLayout();
    if (decisionLayout.addEventListener) decisionLayout.addEventListener('change', setDecisionLayout);
    var picker = root.querySelector('product-variant-swatch, product-variant-dropdown');
    var variants = readJson(root, '[data-aorvo-variants]', []);
    var selectedId = root.querySelector('[data-aorvo-main-form] [name="id"]')?.value;
    var current = variants.find(function (variant) { return String(variant.id) === String(selectedId); });
    var nativeCommerce = root.getAttribute('data-aorvo-native-commerce') === 'true';
    var contractReady = nativeCommerce && root.querySelector('[data-aorvo-attested-media]') ? false : resolveContractState(root, variants);
    if (!picker || !current || (!contractReady && !nativeCommerce)) { failClosed(root); return; }
    if (!transition(picker, current)) return;
    root.removeAttribute('data-aorvo-contract-pending');
    root.aorvoCanaryInitialized = true;
    root.querySelectorAll('[data-aorvo-product-help]').forEach(function (link) {
      link.addEventListener('click', function () {
        var key = 'aorvoAssistedCommerceContextV2';
        try {
          sessionStorage.removeItem(key);
          var state = root.aorvoCurrentState;
          if (!state || root.getAttribute('data-aorvo-state') !== 'ready') return;
          var variant = readJson(root, '[data-aorvo-variants]', []).find(function (item) { return String(item.id) === state.variantId; });
          if (!variant) return;
          var productUrl = new URL(root.getAttribute('data-product-url'), location.origin);
          productUrl.searchParams.set('variant', state.variantId);
          var context = {
            productTitle: link.getAttribute('data-aorvo-help-product-title'),
            productLegacyId: link.getAttribute('data-aorvo-help-product-id'),
            variantId: state.variantId,
            selectedOptions: variant.options.filter(Boolean),
            pdpUrl: productUrl.href,
            requestType: 'Product question'
          };
          sessionStorage.setItem(key, JSON.stringify(context));
        } catch (_) {}
      });
    });
    root.querySelectorAll('[data-aorvo-policy-details]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var policies = root.querySelector('[data-aorvo-decision-role="Purchase policies"]');
        if (!policies) return;
        event.preventDefault();
        policies.open = true;
        policies.scrollIntoView({ block: 'start' });
      });
    });
    var mainForm = root.querySelector('[data-aorvo-main-form]');
    if (mainForm) {
      mainForm.addEventListener('input', function (event) {
        if (event.target.name === 'quantity') syncQuantity(root);
      });
      mainForm.addEventListener('change', function (event) {
        if (event.target.name === 'quantity') syncQuantity(root);
      });
    }
    root.addEventListener('click', function (event) {
      if (event.target.closest('.quick_view-qty-plus, .quick_view-qty-minus')) {
        window.setTimeout(function () { syncQuantity(root); }, 0);
      }
    });
    root.addEventListener('click', function (event) {
      var button = event.target.closest('[name="add"]');
      if (!button || !root.contains(button)) return;
      var form = button.closest('form');
      var state = root.aorvoCurrentState;
      var id = form?.querySelector('[name="id"]')?.value;
      var quantity = Number(form?.querySelector('[name="quantity"]')?.value);
      if (!state || !state.available || id !== state.variantId || quantity !== state.quantity ||
          !Number.isInteger(quantity) || quantity < 1) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    root.querySelectorAll('[data-aorvo-main-form], [data-aorvo-sticky-form]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        var state = root.aorvoCurrentState;
        var id = form.querySelector('[name="id"]')?.value;
        var quantity = Number(form.querySelector('[name="quantity"]')?.value);
        if (!state || !state.available || id !== state.variantId || quantity !== state.quantity) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
    });
  }

  function refreshSelectionOffers() {
    document.querySelectorAll('[data-aorvo-pdp-canary]').forEach(updateSelectionOffer);
  }
  document.addEventListener('DOMContentLoaded', refreshSelectionOffers, { once: true });
  window.addEventListener('load', refreshSelectionOffers, { once: true });

  window.AorvoPdpCanary = { transition: transition };
  async function prepareAttested(root) {
    var nativeMedia = root.querySelector('[data-aorvo-attested-media]');
    if (nativeMedia) {
      if (root.aorvoAttestedPreparation) return root.aorvoAttestedPreparation;
      root.aorvoAttestedPreparation = (async function () {
        var verified = await resolveContractState(root, readJson(root, '[data-aorvo-variants]', []));
        if (!verified || !(root.aorvoPdpViewModel?.attestationVerified || root.aorvoPdpViewModel?.PUBLIC_DISPLAY_VIEW === 1)) return false;
        var content = nativeMedia.content.cloneNode(true);
        var expected = new Set((root.aorvoPdpViewModel.PUBLIC_DISPLAY_VIEW === 1 ? Array.from(new Set(root.aorvoPdpViewModel.variants.flatMap(function(v){return v.media.map(function(m){return m.mediaId.split('/').pop();});}))) : root.aorvoPdpViewModel.media.map(function (m) { return m.mediaGid.split('/').pop(); })));
        var main = Array.from(content.querySelectorAll('#proFeaturedImageZoom > .item'));
        var thumbs = Array.from(content.querySelectorAll('#productThumbs .thumbItem'));
        if (main.length !== expected.size || thumbs.length !== expected.size ||
            main.some(function (node) { return !expected.has(node.getAttribute('data-media-source-id')); }) ||
            thumbs.some(function (node) { return !expected.has(node.getAttribute('data-media-source-id')); })) {
          root.aorvoPdpViewModel = null;
          return false;
        }
        nativeMedia.replaceWith(content);
        var modules = root.querySelector('[data-aorvo-attested-modules]');
        if (modules) modules.replaceWith(modules.content.cloneNode(true));
        if (root.aorvoPdpViewModel.PUBLIC_DISPLAY_VIEW === 1) root.setAttribute('data-aorvo-public-view-validated','true');
        else root.setAttribute('data-aorvo-attestation-verified', 'true');
        root.setAttribute('data-aorvo-media-empty', String(expected.size === 0));
        if (window.AorvoPdpSupport) window.AorvoPdpSupport.initialize();
        if (window.novtheme?.ThumbnailProductDetail) window.novtheme.ThumbnailProductDetail(root);
        return true;
      })().catch(function () { root.aorvoPdpViewModel = null; return false; });
      return root.aorvoAttestedPreparation;
    }
    if (!root.querySelector('[data-aorvo-attested-content]')) return true;
    if (root.aorvoAttestedPreparation) return root.aorvoAttestedPreparation;
    root.aorvoAttestedPreparation = (async function () {
      var verified = await resolveContractState(root, readJson(root, '[data-aorvo-variants]', []));
      if (!verified || !(root.aorvoPdpViewModel?.attestationVerified || root.aorvoPdpViewModel?.PUBLIC_DISPLAY_VIEW === 1)) { failClosed(root); return false; }
      var template = root.querySelector('[data-aorvo-attested-content]');
      var content = template.content.cloneNode(true);
      var expected = new Set((root.aorvoPdpViewModel.PUBLIC_DISPLAY_VIEW === 1 ? Array.from(new Set(root.aorvoPdpViewModel.variants.flatMap(function(v){return v.media.map(function(m){return m.mediaId.split('/').pop();});}))) : root.aorvoPdpViewModel.media.map(function (m) { return m.mediaGid.split('/').pop(); })));
      var main = Array.from(content.querySelectorAll('#proFeaturedImageZoom > .item'));
      var thumbs = Array.from(content.querySelectorAll('#productThumbs .thumbItem'));
      if (main.length !== expected.size || thumbs.length !== expected.size ||
          main.some(function (n) { return !expected.has(n.getAttribute('data-media-source-id')); }) ||
          thumbs.some(function (n) { return !expected.has(n.getAttribute('data-media-source-id')); })) {
        root.setAttribute('data-aorvo-contract-error', 'MEDIA_TEMPLATE_BINDING_MISMATCH'); failClosed(root); return false;
      }
      template.replaceWith(content);
      if (root.aorvoPdpViewModel.PUBLIC_DISPLAY_VIEW === 1) root.setAttribute('data-aorvo-public-view-validated','true');
        else root.setAttribute('data-aorvo-attestation-verified', 'true');
      if (window.AorvoPdpSupport) window.AorvoPdpSupport.initialize();
      if (window.novtheme?.ThumbnailProductDetail) window.novtheme.ThumbnailProductDetail(root);
      return true;
    })().catch(function () { failClosed(root); return false; });
    return root.aorvoAttestedPreparation;
  }
  function start() {
    document.querySelectorAll('[data-aorvo-pdp-canary]').forEach(function (root) {
      if (root.aorvoCanaryInitialized || root.aorvoMediaWaitScheduled) return;
      root.aorvoMediaWaitScheduled = true;
      var attempts = 0;
      function whenRegistered() {
        if (!root.isConnected || root.aorvoCanaryInitialized) return;
        var picker = root.querySelector('product-variant-swatch, product-variant-dropdown');
        var renderer = picker && window.novtheme && window.novtheme.getVariantMediaRenderer &&
          window.novtheme.getVariantMediaRenderer(picker.dataset.productId);
        if (renderer || (root.getAttribute('data-aorvo-native-commerce') === 'true' && root.getAttribute('data-aorvo-media-empty') === 'true')) { init(root); return; }
        if (attempts++ >= 120) { init(root); return; }
        window.setTimeout(whenRegistered, 50);
      }
      if (root.querySelector('[data-aorvo-attested-content], [data-aorvo-attested-media]')) {
        prepareAttested(root).then(function (ok) { if (ok || root.getAttribute('data-aorvo-native-commerce') === 'true') whenRegistered(); });
      } else whenRegistered();
    });
  }
  function startMobileWhenDomReady() {
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    document.querySelectorAll('[data-aorvo-pdp-canary]').forEach(function (root) {
      if (root.querySelector('[data-aorvo-attested-content]')) return;
      initStickyVisibility(root);
      function whenMediaReady() {
        if (!root.isConnected || root.aorvoCanaryInitialized) return;
        var picker = root.querySelector('product-variant-swatch, product-variant-dropdown');
        var renderer = picker && window.novtheme && window.novtheme.getVariantMediaRenderer &&
          window.novtheme.getVariantMediaRenderer(picker.dataset.productId);
        if (renderer && renderer.ownsMedia()) init(root);
        else if (document.readyState !== 'complete') window.requestAnimationFrame(whenMediaReady);
      }
      whenMediaReady();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startMobileWhenDomReady, { once: true });
  } else startMobileWhenDomReady();
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
})();
